import React, { useEffect } from "react";

import useStore, { audio, playAudio } from "../store";

export default function Sound() {
  const sound = useStore((state) => state.sound);
  const soundClick = useStore((state) => state.soundClick);

  useEffect(() => {
    if (sound) {
      playAudio(audio.soundtrack, 0.8, true);
    } else {
      audio.soundtrack.pause();
    }
  }, [sound]);

  function restartAudio() {
    if (sound) {
      playAudio(audio.soundtrack, 0.8, true);
    } else {
      audio.soundtrack.pause();
    }
  }
  React.useEffect(() => {
    window.addEventListener("click", restartAudio);
    return () => {
      window.removeEventListener("click", restartAudio);
    };
  }, [sound]);

  return (
    <div
      onClick={soundClick}
      className={sound ? "sound-button-wrapper" : "sound-button-wrapper muted"}
    >
      <div className="sound-button"></div>
    </div>
  );
}
